// extracted by mini-css-extract-plugin
module.exports = {"container":"_103a151b99--container--gsioT","buttons_container":"_103a151b99--buttons_container--J8043","text":"_103a151b99--text--AdrD6","buttons":"_103a151b99--buttons--mNCL6"};